import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import SocialMedia from '../../components/socialMedia/SocialMedia'

const HomePage = () => {
  const [visitor, setVisitor] = useState()
  useEffect(() => {
    fetch(
      'https://api.countapi.xyz/update/portfolio/706dca47-f358-4563-a2cc-1aa2c5158d67/?amount=1'
    )
      .then((res) => res.json())
      .then((data) => setVisitor(data.value))
  }, [])
  return (
    <div>
      <div className='main-content'>
        <div className='content-left'>
          <div>
            <h4>Hello, I'm</h4>
            <h1>
              T<span>A</span>H<span>A</span>
            </h1>
            <h3>
              A Frontend Web Developer. <span>(React)</span>{' '}
            </h3>

            <div>
              <a href="Taha's_Resume.pdf" download="Taha's_Resume.pdf">
                <button className='btn-primary btn-resume'>
                  Download Resume
                </button>
              </a>
              <Link to='/see-projects'>
                <button className='btn-primary btn-projects'>
                  See All Projects
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className='content-right'>
          <SocialMedia />
        </div>
      </div>
      <div className='visit-icon'>
        <FontAwesomeIcon icon={faEye} />
        <span>{visitor}</span>
      </div>
    </div>
  )
}

export default HomePage
